// extracted by mini-css-extract-plugin
module.exports = {"row":"CampaignRow_row__1ijy5","right":"CampaignRow_right__wjoKS"};